export const clamp = (value: number, min: number, max: number) => {
  return Math.min(Math.max(value, min), max)
}

export const clampPositive = (value: number | string) => {
  return Math.max(1, Number(value))
}

export const lerp = (low: number, high: number, t: number) => {
  return (high - low) * t + low
}

export const degreesToRadians = (degrees: number) => {
  return degrees * (Math.PI / 180)
}
